/** In-game HUD: player stats + live leaderboard + a hint line. */
import { el, hide, show } from './dom';

export interface HudLeaderboardRow {
  name: string;
  score: number;
  isMe: boolean;
}

export interface HudState {
  size: number;
  score: number;
  rank: number;
  total: number;
  rows: HudLeaderboardRow[];
}

export class Hud {
  private readonly root = el('hud');
  private readonly statSize = el('stat-size');
  private readonly statScore = el('stat-score');
  private readonly statRank = el('stat-rank');
  private readonly list = el<HTMLOListElement>('leaderboard-list');
  private readonly hint = el('hint');
  private readonly leaderboardEnabled: boolean;
  private collapsed = false;

  constructor(opts: { leaderboardEnabled: boolean; collapsible: boolean }) {
    this.leaderboardEnabled = opts.leaderboardEnabled;
    if (!this.leaderboardEnabled) {
      hide(el('leaderboard'));
      return;
    }
    // Mobile/touch: make the leaderboard collapsible (default EXPANDED). On
    // desktop it stays a plain, always-open panel.
    if (opts.collapsible) {
      const panel = el('leaderboard');
      const toggle = el<HTMLButtonElement>('leaderboard-toggle');
      panel.classList.add('collapsible');
      toggle.addEventListener('click', (e) => {
        // Toggle only — never let the tap fall through to a game action.
        e.preventDefault();
        this.collapsed = !this.collapsed;
        panel.classList.toggle('collapsed', this.collapsed);
        toggle.setAttribute('aria-expanded', String(!this.collapsed));
      });
    }
  }

  show(): void {
    show(this.root);
  }
  hide(): void {
    hide(this.root);
  }

  setHint(text: string): void {
    this.hint.textContent = text;
  }

  update(state: HudState): void {
    this.statSize.textContent = String(Math.round(state.size));
    this.statScore.textContent = String(state.score);
    this.statRank.textContent = `${state.rank}/${state.total}`;

    if (!this.leaderboardEnabled) return;
    // Rebuild the short list (cheap; orchestrator throttles this call).
    this.list.replaceChildren(
      ...state.rows.map((row) => {
        const li = document.createElement('li');
        li.textContent = `${row.name} · ${row.score}`;
        if (row.isMe) li.className = 'me';
        return li;
      }),
    );
  }
}
